module.exports = __webpack_public_path__ + "img/装箱单.5582f93a.svg";